import { useQueryClient } from '@tanstack/react-query';
import { components } from 'src/generated/v1';
import { $api } from './api';
import { invalidateProductQueries } from './productsNew';

// const getProductPackagings = async (productId: number) => {
//   const apiClient = getProductApiClient();
//   return apiClient.getAllPackagingsProductsProductIdPackagingsGet({ productId });
// };

export type ProductPackaging = components['schemas']['ProductPackaging'];

// Hook for fetching Product Packagings
export const useProductPackagings = (productId: number, enabled: boolean) => {
  // return useQuery({
  //   queryKey: ['productPackagings', productId],
  //   queryFn: () => getProductPackagings(productId),
  //   enabled,
  // });

  return $api.useQuery(
    'get',
    '/products/{product_id}/packagings/',
    {
      params: {
        path: {
          product_id: productId,
        },
      },
    },
    { enabled },
  );
};

// Create Product Packaging
// const createProductPackaging = async (productId: number, packagingData: ProductPackagingIn): Promise<void> => {
//   const apiClient = getProductApiClient();

//   await apiClient.createPackagingProductsProductIdPackagingsPost({
//     productId,
//     productPackagingIn: packagingData,
//   });
// };

// Delete Product Packaging
// const deleteProductPackaging = async (packagingId: number): Promise<void> => {
//   const apiClient = getProductApiClient();
//   await apiClient.deletePackagingProductsPackagingsPackagingIdDelete({ packagingId });
// };

// Update Product Packaging
// const updateProductPackaging = async (packagingId: number, packagingData: ProductPackagingUpdateIn): Promise<void> => {
//   const apiClient = getProductApiClient();
//   await apiClient.updatePackagingProductsPackagingsPackagingIdPut({
//     packagingId,
//     productPackagingUpdateIn: packagingData,
//   });
// };

function invalidate(queryClient: ReturnType<typeof useQueryClient>) {
  invalidateProductQueries(queryClient);
  const keys = [['get', '/products/{product_id}/packagings/']];
  keys.forEach(key => {
    queryClient.invalidateQueries({ queryKey: key });
  });
}

// Hook to use Product Packaging mutations
export const useProductPackaging = () => {
  const queryClient = useQueryClient();

  // const createMutation = useMutation({
  //   mutationFn: ({ productId, packagingData }: { productId: number; packagingData: ProductPackagingIn }) => {
  //     if (!productId) {
  //       return Promise.reject(new Error('Product ID is required to create packaging'));
  //     }
  //     return createProductPackaging(productId, packagingData);
  //   },
  //   onSuccess: (_data, variables) => {
  //     queryClient.invalidateQueries({ queryKey: ['productPackagings', variables.productId] });
  //   },
  // });

  const createMutation = $api.useMutation('post', '/products/{product_id}/packagings/', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  // const deleteMutation = useMutation({
  //   mutationFn: ({ packagingId }: { packagingId: number }) => {
  //     if (!packagingId) {
  //       return Promise.reject(new Error('Packaging ID is required to delete packaging'));
  //     }
  //     return deleteProductPackaging(packagingId);
  //   },
  //   onSuccess: () => {
  //     queryClient.invalidateQueries({ queryKey: ['productPackagings'] }); // Invalidate all packaging queries
  //   },
  // });

  const deleteMutation = $api.useMutation('delete', '/products/packagings/{packaging_id}', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  // const updateMutation = useMutation({
  //   mutationFn: ({ packagingId, packagingData }: { packagingId: number; packagingData: ProductPackagingIn }) => {
  //     if (!packagingId) {
  //       return Promise.reject(new Error('Packaging ID is required to update packaging'));
  //     }
  //     return updateProductPackaging(packagingId, packagingData);
  //   },
  //   onSuccess: () => {
  //     queryClient.invalidateQueries({ queryKey: ['productPackagings'] }); // Invalidate all packaging queries
  //   },
  // });

  const updateMutation = $api.useMutation('put', '/products/packagings/{packaging_id}', {
    onSuccess() {
      invalidate(queryClient);
    },
  });

  return {
    createPackaging: createMutation.mutate,
    createPackagingAsync: createMutation.mutateAsync,
    deletePackaging: deleteMutation.mutate,
    deletePackagingAsync: deleteMutation.mutateAsync,
    updatePackaging: updateMutation.mutate,
    updatePackagingAsync: updateMutation.mutateAsync,
    isPendingCreate: createMutation.isPending,
    isPendingDelete: deleteMutation.isPending,
    isPendingUpdate: updateMutation.isPending,
    createError: createMutation.error,
    deleteError: deleteMutation.error,
    updateError: updateMutation.error,
  };
};
